import React from "react";
import { useForm, Controller } from "react-hook-form";

import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Paper,
  Typography,
  IconButton,
  CardContent,
  CardActions,
  Button,
  MenuItem,
  Input,
  FormControl,
  Select,
  InputLabel,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { KeyboardDatePicker } from "@material-ui/pickers";

import CloseIcon from "@material-ui/icons/Close";
import FullscreenIcon from "@material-ui/icons/Fullscreen";

const useStyles = makeStyles((theme) => ({
  label: {
    fontSize: "14px",
    color: "#757575",
    textAlign: "left",
    marginTop: "4px",
  },
  formControl: {
    minWidth: 250,
  },
}));

export const AdvanceSearch = React.memo((props) => {
  const classes2 = useStyles();
  const {
    classes,
    handleToggle,
    isLanguages,
    isDialects,
    clearAdvancedSearchHandler,
    handleMinimize,
    isMinimize,
    setIsSearchObj,
    isSearchObj,
    setIsSearchMode,
    setIsSearching,
  } = props;

  const formValue = {
    name: isSearchObj?.name,
    language: isSearchObj?.language,
    dialect: isSearchObj?.dialect,
    status: isSearchObj?.status,
    date: isSearchObj?.date,
    from: isSearchObj?.from,
    to: isSearchObj?.to,
  };

  const { register, handleSubmit, errors, control, setValue, reset } = useForm({
    mode: "onChange",
    defaultValues: formValue,
  });

  const clearFieldsHandler = () => {
    reset({
      name: "",
      language: "",
      dialect: "",
      from: null,
      to: null,
      cfrom: null,
      cto: null,
      date: null,
    });
    clearAdvancedSearchHandler();
    setIsSearching(false);
  };

  const onSubmit = async (data) => {
    if (data.from instanceof Date) data.from = data.from.toISOString();
    if (data.to instanceof Date) data.to = data.to.toISOString();

    setIsSearchObj(data);
    setIsSearching(true);
  };

  const handleChange = (e, targetName) => {
    console.log(e);
    setValue(
      targetName ? targetName : e.target.name,
      (e && e.target && e.target.value) || e,
      { shouldDirty: true },
    );
  };

  return (
    <React.Fragment>
      <div style={{ display: isMinimize ? "none" : "block" }}>
        <Paper className={classes.advanceCard} elevation={3}>
          <form onSubmit={(e) => e.preventDefault()}>
            <CardContent>
              <Grid
                container
                direction="row"
                justify="flex-end"
                alignItems="flex-end"
              >
                <IconButton
                  aria-label="close"
                  size="small"
                  onClick={handleToggle}
                >
                  <CloseIcon />
                </IconButton>
              </Grid>
              <Grid container direction="row" spacing={1}>
                {/* Name */}
                <Grid item xs={2} className={classes2.label}>
                  <Typography variant="body2">Name</Typography>
                </Grid>
                <Grid item xs={10}>
                  <Input
                    placeholder="Candidate Name"
                    fullWidth
                    name="name"
                    inputRef={register}
                    defaultValue={formValue?.name || ""}
                  />
                </Grid>

                {/* Language */}
                <Grid item xs={2} className={classes2.label}>
                  <Typography variant="body2" style={{ marginTop: "8px" }}>
                    Language
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  <Autocomplete
                    style={{ marginTop: "4px" }}
                    options={isLanguages}
                    filterSelectedOptions
                    onChange={(e, value) =>
                      handleChange(value ? value.language : "", "language")
                    }
                    defaultValue={
                      isLanguages.find(
                        (l) => l.language === formValue?.language,
                      ) || null
                    }
                    getOptionLabel={(option) => option.language || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        fullWidth
                        placeholder="Language"
                      />
                    )}
                  />
                  <input
                    type="hidden"
                    name="language"
                    ref={register}
                    defaultValue={formValue?.language || ""}
                  />
                </Grid>

                {/* Dialect */}
                <Grid item xs={5}>
                  <Autocomplete
                    style={{ marginTop: "4px" }}
                    options={isDialects}
                    filterSelectedOptions
                    onChange={(e, value) =>
                      handleChange(value ? value.dialect : "", "dialect")
                    }
                    defaultValue={
                      isDialects.find(
                        (d) => d.dialect === formValue?.dialect,
                      ) || null
                    }
                    getOptionLabel={(option) => option.dialect || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        fullWidth
                        placeholder="Dialect"
                      />
                    )}
                  />
                  <input
                    type="hidden"
                    name="dialect"
                    ref={register}
                    defaultValue={formValue?.dialect || ""}
                  />
                </Grid>

                {/* Status */}
                <Grid item xs={2} className={classes2.label}>
                  <Typography variant="body2" style={{ marginTop: "10px" }}>
                    Status
                  </Typography>
                </Grid>

                <Grid item xs={10}>
                  <FormControl
                    size="small"
                    fullWidth
                    style={{ marginTop: "4px" }}
                  >
                    <Controller
                      as={
                        <Select>
                          <MenuItem value="none">All</MenuItem>
                          <MenuItem value="New">New</MenuItem>
                          <MenuItem value="Upcoming Interviews">
                            Upcoming Interviews
                          </MenuItem>
                          <MenuItem value="Interviewed">Interviewed</MenuItem>
                          <MenuItem value="Reg Docs Sent">
                            Reg Docs Sent
                          </MenuItem>
                          <MenuItem value="Reg Docs Received">
                            Reg Docs Received
                          </MenuItem>
                          <MenuItem value="Profile Created">
                            Profile Created
                          </MenuItem>
                          <MenuItem value="References Requested">
                            References Requested
                          </MenuItem>
                          <MenuItem value="References Received">
                            References Received
                          </MenuItem>
                          <MenuItem value="Declined By LIL">
                            Declined By LIL
                          </MenuItem>
                          <MenuItem value="Declined By IP">
                            Declined By IP
                          </MenuItem>
                          <MenuItem value="Docs Uploaded / Awaiting Activation">
                            Docs Uploaded / Awaiting Activation
                          </MenuItem>
                          <MenuItem value="Activated">Activated</MenuItem>
                          <MenuItem value="Deactivated">Deactivated</MenuItem>
                          <MenuItem value="Duplicate">Duplicate</MenuItem>
                        </Select>
                      }
                      control={control}
                      name="status"
                      defaultValue={formValue?.status || "none"}
                    />
                  </FormControl>
                </Grid>

                {/* Date Range */}
                <Grid item xs={2} className={classes2.label}>
                  <Typography variant="body2" style={{ marginTop: "14px" }}>
                    Received Date
                  </Typography>
                </Grid>

                {/* From */}
                <Grid item xs={5}>
                  <Controller
                    as={
                      <KeyboardDatePicker
                        size="small"
                        margin="normal"
                        format="dd/MM/yyyy"
                        placeholder="From"
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                      />
                    }
                    control={control}
                    name="from"
                    defaultValue={formValue?.from || null}
                  />
                </Grid>

                {/* To */}
                <Grid item xs={5}>
                  <Controller
                    as={
                      <KeyboardDatePicker
                        size="small"
                        margin="normal"
                        format="dd/MM/yyyy"
                        placeholder="To"
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                      />
                    }
                    control={control}
                    name="to"
                    defaultValue={formValue?.to || null}
                  />
                </Grid>
              </Grid>
            </CardContent>
            <CardActions>
              <Grid
                container
                direction="row"
                justify="flex-end"
                alignItems="flex-end"
                style={{ marginTop: "12px" }}
              >
                <Button color="primary" onClick={clearFieldsHandler}>
                  Clear
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit(onSubmit)}
                >
                  Search
                </Button>
              </Grid>
            </CardActions>
          </form>
        </Paper>
      </div>
    </React.Fragment>
  );
});
